/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  HobbiesResponseDto,
  HobbiesUpsertRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    HobbiesResponseDtoFromJSON,
    HobbiesResponseDtoToJSON,
    HobbiesUpsertRequestDtoFromJSON,
    HobbiesUpsertRequestDtoToJSON,
} from '../models/index';

export interface GetHobbiesByPatientIdRequest {
    patientId: string;
}

export interface UpsertHobbiesRequest {
    hobbiesUpsertRequestDto: HobbiesUpsertRequestDto;
}

export interface UpsertHobbiesByPatientIdRequest {
    patientId: string;
    hobbiesUpsertRequestDto: HobbiesUpsertRequestDto;
}

/**
 * 
 */
export class PatientHobbiesApi extends runtime.BaseAPI {

    /**
     * Get patient\'s hobbies intake
     */
    async getHobbiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HobbiesResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/hobbies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HobbiesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s hobbies intake
     */
    async getHobbies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HobbiesResponseDto> {
        const response = await this.getHobbiesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s hobbies intake by patient ID
     */
    async getHobbiesByPatientIdRaw(requestParameters: GetHobbiesByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HobbiesResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getHobbiesByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/hobbies/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HobbiesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s hobbies intake by patient ID
     */
    async getHobbiesByPatientId(requestParameters: GetHobbiesByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HobbiesResponseDto> {
        const response = await this.getHobbiesByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create/update patient\'s hobbies intake
     */
    async upsertHobbiesRaw(requestParameters: UpsertHobbiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HobbiesResponseDto>> {
        if (requestParameters['hobbiesUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'hobbiesUpsertRequestDto',
                'Required parameter "hobbiesUpsertRequestDto" was null or undefined when calling upsertHobbies().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/hobbies`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HobbiesUpsertRequestDtoToJSON(requestParameters['hobbiesUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HobbiesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create/update patient\'s hobbies intake
     */
    async upsertHobbies(requestParameters: UpsertHobbiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HobbiesResponseDto> {
        const response = await this.upsertHobbiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create/update patient\'s hobbies intake by patient ID
     */
    async upsertHobbiesByPatientIdRaw(requestParameters: UpsertHobbiesByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HobbiesResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling upsertHobbiesByPatientId().'
            );
        }

        if (requestParameters['hobbiesUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'hobbiesUpsertRequestDto',
                'Required parameter "hobbiesUpsertRequestDto" was null or undefined when calling upsertHobbiesByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/hobbies/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HobbiesUpsertRequestDtoToJSON(requestParameters['hobbiesUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HobbiesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create/update patient\'s hobbies intake by patient ID
     */
    async upsertHobbiesByPatientId(requestParameters: UpsertHobbiesByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HobbiesResponseDto> {
        const response = await this.upsertHobbiesByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
